import { Component, Inject } from "@angular/core";
import { UntypedFormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import {
  EnumHelper,
  FailureReasonUsage,
  FormHelper,
  SubtransactionTypeInternalLabel,
  TransactionStatus,
  TransactionType,
  TransferMethod,
  TransferMethodLabel,
  TransferSource,
  TransferSourceLabel
} from 'common';
import { Observable } from "rxjs";
import { TransactionData } from '../transaction.model';

@Component({
    selector: 'ifb-transaction-details-update-dialog',
    templateUrl: './transaction-details-update-dialog.component.html',
    styleUrls: ['./transaction-details-update-dialog.component.css'],
    standalone: false
})
export class TransactionDetailsUpdateDialogComponent {

  status: string;
  statusUpdated: string;
  nextStatus: string;
  nextStatusUpdated: string;
  type: string;
  transferMethod: string;
  transferSource: string;
  promotions: string;
  competitors: string;
  readonly FailureReasonUsage = FailureReasonUsage;
  readonly TransactionStatus = TransactionStatus;

  constructor(public dialogRef: MatDialogRef<TransactionDetailsUpdateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.status = EnumHelper.getNameFromValue(TransactionStatus, this.data.form.value.status);
    this.statusUpdated = EnumHelper.getNameFromValue(TransactionStatus, this.data.status);
    this.nextStatus = EnumHelper.getNameFromValue(TransactionStatus, this.data.form.value.nextStatus);
    this.nextStatusUpdated = EnumHelper.getNameFromValue(TransactionStatus, this.data.nextStatus);
    this.type = EnumHelper.getNameFromValue(TransactionType, this.data.transaction.type);
    this.transferMethod = EnumHelper.getMappedNameFromValue(TransferMethod, TransferMethodLabel, this.data.form.value.transferMethod);
    this.transferSource = EnumHelper.getMappedNameFromValue(TransferSource, TransferSourceLabel, this.data.form.value.transferSource);
    this.promotions = this.data.promotions;
    this.competitors = this.data.competitors;
  }

  getSubtransactionTypeName(type: number): string {
    return SubtransactionTypeInternalLabel.get(type);
  }

  save() {
    if (this.data.status === TransactionStatus.Rejected) {
      FormHelper.showInvalidFormFields(this.data.form);
      if (!this.data.form.controls.reasons.valid)
        return;
    }
    this.dialogRef.close(true);
  }

  // eslint-disable-next-line max-len
  static show(dialog: MatDialog, form: UntypedFormGroup, notes: any[], transaction?: TransactionData, status?: TransactionStatus, transactionNew?: boolean, promotions?: string, competitors?: string): Observable<any> {
    return dialog.open(TransactionDetailsUpdateDialogComponent, {
      width: '510px',
      data: {
        form: form,
        notes: notes,
        transaction: transaction,
        status: status,
        transactionNew: transactionNew,
        promotions: promotions,
        competitors
      },
      closeOnNavigation: true,
    }).afterClosed();
  }

}
